import { TextCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

export const workOrderDueDateColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = TextCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'due_date',
  title: 'Срок',
  width: 140,
  placeholder: 'YYYY-MM-DD',
});
